import React from 'react';
// import './LexiLiteAIHeader.css';

const LexiLiteAIHeader = () => (
  <div className="product-header-block sub-lexilite">
    <div className="product-header-content">
      <span className="badge-ondevice">Apple CoreML Native</span>
      <h2>LexiLiteAI</h2>
      <p>Real-Time Edge Speech Intelligence & Fluency Profiling</p>
    </div>
  </div>
);

export default LexiLiteAIHeader;
